import { ThemeProvider } from "@emotion/react";
import { createTheme, TextField } from "@mui/material";
import React from "react";
import { colors } from "../../common/pallette/colors";

export const TextAreaWithoutBorders = (props:any) => {
    const { value, handleChange, placeholder, manageOnBlur, rows, isReadOnly, isResize } = props;
    const theme = createTheme({
      components: {
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              backgroundColor: colors.grey.bright,
              "&.Mui-focused": {
                backgroundColor: colors.grey.bright,
              },
              padding: 0,
            },
            input: {
                padding: '6px',
                fontSize: '12px'
            }
          },
        },
      },
    });
    
    return(
        <ThemeProvider theme={theme}>
            <TextField
              sx={{
                // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black', // Makes the input text black
                  cursor: isReadOnly ? 'not-allowed' : 'text'
                },
                // Enable resize functionality
                '& .MuiInputBase-root': {
                  resize: isResize ? 'vertical' : 'none', // Allows vertical resizing only
                },
                '& textarea': {
                  resize: isResize ? 'vertical' : 'none', // Targets the textarea element directly
                  '&::-webkit-resizer': {
                  border: '20px solid transparent', // Increase from default ~4px
                  borderRight: '20px solid #999', // Color and size of the handle
                  borderBottom: '20px solid #999',
                }
                }
              }}
              rows={rows ? rows : 4}
              multiline
              fullWidth
              value={value}
              onChange={handleChange}
              placeholder={placeholder}
              onBlur={manageOnBlur}
              disabled={isReadOnly}
            />
        </ThemeProvider>
    )
}